export default (float, val) => {
    const percentage = (val/100) * float
    return val + percentage
}